var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21580_8397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38347 15.9999C7.56656 15.9999 6.75713 15.7619 6.12009 15.2932L2.89739 12.5181C2.043 11.8858 1.37598 10.5616 1.37598 9.51265V4.36493C1.37598 3.21928 2.22287 1.99924 3.3096 1.59752L7.04942 0.206379C7.79139 -0.0688742 8.96056 -0.0688742 9.70253 0.206379L13.4424 1.59752C14.5291 1.99924 15.376 3.21928 15.376 4.36493V9.50521C15.376 10.5616 14.709 11.8783 13.8546 12.5107L10.6319 15.2858C10.0098 15.7619 9.20039 15.9999 8.38347 15.9999Z",
    fill: "#F5C300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3728 4.19989V8.6444",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36743 11.3112H8.37573",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21580_8397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.375977)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldWarning);
export default __webpack_public_path__ + "static/media/shield-warning.a09f53efe0e9a567842a6cc00f900b71.svg";
export { ForwardRef as ReactComponent };